import React, { FC, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import s from './AppointmentBooking.module.scss';
import clsx from 'clsx';
import ProfileMenuHeader from 'modules/app/components/ProfileMenu/ProfileMenuHeader';
import ChooseServices from './ChooseServices';
import SelectProfessional from './SelectProfessional';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';
import BookingCalendar from 'components/shared/BookingCalendar';
import BookingCheckoutMulti from './BookingCheckout/BookingCheckoutMulti';
import useUpdateMultiAvailabilityTime from 'sdk/hooks/booking/useUpdateMultiAvailabilityTime';
import supabase from 'sdk/api';
import useIsAuth from 'sdk/hooks/useIsAuth';
import ChooseLocation from 'components/shared/ChooseLocation';
import OrdersList from './OrdersList';
import Steps from './Steps';
import useGetServicePricingDurationByVideo from 'sdk/hooks/booking/useGetServicePricingDurationByVideo';
import { useTranslation } from 'react-i18next';
import Page from 'modules/app/components/Page';
import PaymentOption from '../AppointmentBookingSpec/PaymentOption';
import useGetAllServicePricingDuration from 'sdk/hooks/booking/useGetAllServicePricingDuration';
import { a } from '@react-spring/web';

export enum AppointmentBookingSteps {
  CHOOSE_SERVICES = 'Choose services',
  CHOOSE_SERVICES_BOOK = 'Choose services book',
  SELECT_THE_PROFESSIONAL = 'Select the professional',
  CHOOSE_DATE = 'Choose date',
  CHOOSE_PAYMENT_OPTION = 'Choose payment option',
  CHECKOUT = 'Booking checkout',
  VOUCHER_EMAIL = 'Voucher email',
  VOUCHER_TIME = 'Voucher time',
  VOUCHER_RESULT = 'Voucher result',
  CHOOSE_LOCATION = 'Choose location',
  ORDERS_LIST = 'Orders list',
}

interface SelectedDay {
  year: number;
  month: number;
  day: number;
}

type Props = {};




const AppointmentBooking: FC<Props> = (): JSX.Element => {
  const navigate = useNavigate();
  const { isAppointmentBookingOpen } = useTypedSelector(state => state.postSlice);
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const [selectedLocation, setSelectedLocation] = useState(null);
  const { salonId } = useParams();
  const [searchParams] = useSearchParams();
  const serviceLocation = searchParams.get('serviceLocation');
  const preSelectedServiceId = searchParams.get('serviceId');
  const { t } = useTranslation() as any;
  const { data: services, refetch: refetchServices } = useGetServicePricingDurationByVideo(
      salonId || '',
      selectedLocation || '',
  );
  const { mutate, mutateAsync } = useUpdateMultiAvailabilityTime();
  const [selectedServices, setSelectedServices] = useState<any>([]);
  const [selectedProf, setSelectedProf] = useState(null);
  const [currentServiceId, setCurrentServiceId] = useState<string | null>(null);
  const [duration, setDuration] = useState(0);
  const [price, setPrice] = useState(0);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedEndTime, setSelectedEndTime] = useState(null);
  const [selectedDay, setSelectedDay] = useState<SelectedDay | null>(null);
  const [paymentMethod, setPaymentMethod] = useState(null);

  const [homeLocation, setHomeLocation] = useState({
    street: '',
    apartment: '',
    floor: '',
    entrance: '',
    note: '',
    intercom: '',
    name: '',
    phone: '',
  });

  const [bookingTransactions, setBookingTransactions] = useState<any>([]);
  const [selectedServiceHistory, setSelectedServiceHistory] = useState<any>([]);
  interface BookingItemWithDiscount {
    service: any;
    price: any;
  }
  const [bookingItemsWithDiscount, setBookingItemsWithDiscount] = useState<BookingItemWithDiscount[]>([]);
  const [isSubmittingBooking, setIsSubmittingBooking] = useState(false);
  const {data: allServicePricingDurationByService} = useGetAllServicePricingDuration();

  const [step, setStep] = useState(AppointmentBookingSteps.CHOOSE_LOCATION);
  const isChooseServices = AppointmentBookingSteps.CHOOSE_SERVICES;
  const isSelectProfessional = AppointmentBookingSteps.SELECT_THE_PROFESSIONAL;
  const isChooseDate = AppointmentBookingSteps.CHOOSE_DATE;
  const isChoosePaymentOption = AppointmentBookingSteps.CHOOSE_PAYMENT_OPTION;
  const isCheckout = AppointmentBookingSteps.CHECKOUT;
  const isChooseLocation = AppointmentBookingSteps.CHOOSE_LOCATION;
  const isOrdersList = AppointmentBookingSteps.ORDERS_LIST;

  const handleCloseMenu = (): void => {
    if (step === isChooseLocation) {
      navigate(-1);
      return;
    }
    if (step === isChooseServices) {
      setDuration(0);
      setPrice(0);
      setSelectedServiceHistory([]);
      setStep(isChooseLocation);

      return;
    }
    if (step === isSelectProfessional) {
      setSelectedProf(null);
      setBookingTransactions([]);
      if (preSelectedServiceId) {
        setStep(isChooseLocation);
      } else {
        setStep(isChooseServices);
      }
      return;
    }

    if (step === isChooseDate) {
      setSelectedTime(null);
      setSelectedEndTime(null);
      setSelectedDay(null);
      setStep(isSelectProfessional);
      if (selectedServices.length === 0) {
        setSelectedServices([selectedServiceHistory[selectedServiceHistory.length - 1]]);
      }
      return;
    }

    if (step === isChoosePaymentOption) {
      setPaymentMethod(null);
      setBookingTransactions(prev => {
        return prev.slice(0, -1)
      });
      setStep(isChooseDate);
      return;
    }

    if (step === isCheckout) {
      setStep(isChooseDate);
      return;
    }

    if (step === isOrdersList) {
      setStep(isChoosePaymentOption);
      return;
    }
  };

  const settingAppointments = (): void => {
    // Проверяем, нет ли уже такой записи
    const isDuplicate = bookingTransactions.some(
        transaction =>
            transaction.team_id === selectedProf &&
            (selectedDay
                ? transaction.date ===
                `${selectedDay.year}-${String(selectedDay.month).padStart(2, '0')}-${String(
                    selectedDay.day,
                ).padStart(2, '0')}`
                : false) &&
            transaction.start_time === selectedTime &&
            transaction.service === currentServiceId,
    );

    if (isDuplicate) {
      return; // Прерываем выполнение функции если найден дубликат
    }

    setBookingTransactions((prev) => {
      
      //TODO: It is a hack to make wizzard works since it doesn't count duration and price correctly for multiple services
      const priceDuration =  allServicePricingDurationByService?.find(item => item.service === currentServiceId);

      // Relly existing price and duration
      const price = priceDuration ? priceDuration.price : -1;
      const duration = priceDuration ? priceDuration.duration : -1;

      return [
        ...prev,
        {
          order_id: 'Offline',
          team_id: selectedProf,
          start_time: selectedTime,
          end_time: selectedEndTime,
          duration,
          //@ts-ignore
          date: selectedDay
              ? `${selectedDay.year}-${String(selectedDay.month).padStart(2, '0')}-${String(
                  selectedDay.day,
              ).padStart(2, '0')}`
              : '',
          status: 'Booked',
          user_id: isAuthData?.user?.id,
          price: price,
          service: currentServiceId,
        },
      ]
    });
    // setSelectedDay(null);
    // setSelectedTime(null);
  };

  const handleDeleteBooking = index => {
    const newBookingTransactions = [...bookingTransactions];
    const newSelectedServiceHistory = [...selectedServiceHistory];
    const newBookingItemsWithDiscount = [...bookingItemsWithDiscount];

    newBookingTransactions.splice(index, 1);
    newSelectedServiceHistory.splice(index, 1);
    newBookingItemsWithDiscount.splice(index, 1);

    setBookingTransactions(newBookingTransactions);
    setSelectedServiceHistory(newSelectedServiceHistory);
    setBookingItemsWithDiscount(newBookingItemsWithDiscount);
  };

  useEffect(() => {
    refetchServices();
  }, [isAppointmentBookingOpen]);

  useEffect(() => {
    if (preSelectedServiceId && services?.length) {
      const foundService = services.find(s => s.service === preSelectedServiceId);
      if (foundService) {
        setSelectedServices([foundService.service]);
        setSelectedServiceHistory([foundService.service]);
        setDuration(foundService.duration || 0);
        setPrice(Number(foundService.price) || 0);
        setBookingItemsWithDiscount([{
          service: foundService.service,
          price: foundService.price
        }]);
      }
    }
  }, [services, preSelectedServiceId]);



  const handleOfflineBooking = async () => {
    if (!bookingTransactions.length || isSubmittingBooking) return;

    setIsSubmittingBooking(true);

    const generatedNumber = Math.floor(100000 + Math.random() * 900000);

    const results = await Promise.all(
        bookingTransactions.map(transaction =>
            mutateAsync({
              teamId: transaction.team_id,
              date: transaction.date,
              startTime: transaction.start_time,
              duration: transaction.duration,
              record_id: generatedNumber,
            }).catch(error => {
              return null;
            }),
        ),
    );

    // После успешного обновления всех записей доступности
    const totalPrice = bookingTransactions.reduce(
        (sum, order) => sum + (order.price || 0),
        0,
    );

    const bookedTimes = bookingTransactions.reduce((acc, item) => {
      acc[`teamId_${item.team_id}`] = {
        start_time: item.start_time,
        end_time: item.end_time,
        duration: item.duration,
        date: item.date,
      };
      return acc;
    }, {} as Record<string, any>);

    const { data: transactions, error } = await supabase
        .from('booking_transactions')
        .insert({
          team_id: selectedProf,
          date: selectedDay
              ? `${selectedDay.year}-${String(selectedDay.month).padStart(2, '0')}-${String(
                  selectedDay.day,
              ).padStart(2, '0')}`
              : '',
          duration,
          order_id: 'Offline',
          status: 'Booked',
          user_id: userId,
          price: totalPrice,
          start_time: selectedTime,
          end_time: selectedEndTime,
          service: selectedServiceHistory[0],
          service_ids: { serviceIds: selectedServiceHistory },
          booked_times: bookedTimes,
          home_address: homeLocation,
          salon_id: salonId,
          record_id: generatedNumber,
        })
        .select('*');

    if (error) {
      setIsSubmittingBooking(false);
      return;
    }

    try {
      await supabase.functions.invoke('send-booking-email', {
        body: { booking_transaction_id: transactions[0]?.id },
      });
    } catch (emailError) {
      console.error('Failed to send booking email:', emailError);
    }

    setIsSubmittingBooking(false);
    navigate(`/booking/${transactions[0]?.id}`);
  };


  return (
      <div className={clsx(s.appointment_booking)}>
        <ProfileMenuHeader text={'appointments_bookings'} onClose={handleCloseMenu} />
        {step !== isOrdersList && step !== isCheckout && <Steps step={step} />}

        {step === isChooseLocation && (
            <ChooseLocation
                handleNext={() => {
                  if (preSelectedServiceId) {
                    setStep(AppointmentBookingSteps.SELECT_THE_PROFESSIONAL);
                  } else {
                    setStep(AppointmentBookingSteps.CHOOSE_SERVICES);
                  }
                }}
                homeLocation={homeLocation}
                setHomeLocation={setHomeLocation}
                setSelectedLocation={setSelectedLocation}
                preSelectedLocationType={serviceLocation}
            />
        )}
        {step === isChooseServices && (
            <ChooseServices
                services={services}
                selectedIds={selectedServices}
                handleChoose={setSelectedServices}
                setDuration={setDuration}
                setPrice={setPrice}
                handleNext={() => {
                  setStep(AppointmentBookingSteps.SELECT_THE_PROFESSIONAL);
                  setSelectedServiceHistory(selectedServices);
                }}
                setSelectedServiceHistory={setSelectedServiceHistory}
                setBookingItemsWithDiscount={setBookingItemsWithDiscount}
            />
        )}
        {step === isSelectProfessional && (
            <SelectProfessional
                selectedService={[selectedServices[0]]}
                selectedId={selectedProf}
                handleChoose={setSelectedProf}
                handleNext={() => {
                  const firstService = selectedServices[0];
                  setCurrentServiceId(typeof firstService === 'object' ? firstService.id : firstService);
                  setSelectedServices(selectedServices.slice(1));
                  setStep(AppointmentBookingSteps.CHOOSE_DATE);
                }}
            />
        )}
        {step === isChooseDate && (
            <BookingCalendar
                teamId={selectedProf}
                salonId={salonId}
                selectedTime={selectedTime}
                setSelectedTime={setSelectedTime}
                setSelectedEndTime={setSelectedEndTime}
                selectedDay={selectedDay}
                setSelectedDay={setSelectedDay}
                handleNext={() => {
                  if (selectedServices.length === 0) {
                    settingAppointments();
                    // setStep(AppointmentBookingSteps.CHOOSE_PAYMENT_OPTION)
                    setStep(AppointmentBookingSteps.CHOOSE_PAYMENT_OPTION);
                  } else {
                    settingAppointments();
                    setStep(AppointmentBookingSteps.SELECT_THE_PROFESSIONAL);
                  }
                }}
                duration={duration}
                selectedServices={selectedServices}
                selectedServiceHistory={selectedServiceHistory}
                currentServiceId={currentServiceId}
                alreadyBookedTimes={bookingTransactions}
            />
        )}

        {step === isOrdersList && (
            <OrdersList
                handleNext={() => setStep(AppointmentBookingSteps.CHECKOUT)}
                selectedServiceHistory={selectedServiceHistory}
                bookingTransactions={bookingTransactions}
                onDelete={handleDeleteBooking}
                price={price}
                bookingItemsWithDiscount={bookingItemsWithDiscount}
            />
        )}
        {step === isChoosePaymentOption && (
            <PaymentOption
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                serviceId={selectedServiceHistory}
                isLoading={isSubmittingBooking}
                handleNext={() => {
                  if (paymentMethod === 'online') {
                    setStep(AppointmentBookingSteps.ORDERS_LIST);
                  } else {
                    handleOfflineBooking();
                  }
                }}
            />
        )}
        {step === isCheckout && (
            <BookingCheckoutMulti
                price={price}
                teamId={selectedProf}
                bookingTransactions={bookingTransactions}
                duration={duration}
                selectedTime={selectedTime}
                selectedEndTime={selectedEndTime}
                date={
                  selectedDay
                      ? `${selectedDay.year}-${String(selectedDay.month).padStart(2, '0')}-${String(
                          selectedDay.day,
                      ).padStart(2, '0')}`
                      : ''
                }
                selectedServiceHistory={selectedServiceHistory}
                homeLocation={homeLocation}
                salonId={salonId}
                bookingItemsWithDiscount={bookingItemsWithDiscount}
                setBookingItemsWithDiscount={setBookingItemsWithDiscount}
            />
        )}
      </div>
  );
};

export default AppointmentBooking;
